export { ClickAwayListener as default } from './ClickAwayListener';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ClickAwayListener/index.js
// module id = 242
// module chunks = 25